// extracted by mini-css-extract-plugin
module.exports = {"title":"not-found_title__kP_YO","paragraph":"not-found_paragraph___2ZY0","contactErrorLink":"not-found_contactErrorLink__o7hOF"};